import { z } from 'zod';

import { BasePType } from './base';

export const RichTextLink = BasePType.extend({
  url: z.string(),
  target: z.enum(['_blank', '_self']).optional(),
  klass: z.union([z.string(), z.array(z.string())]).nullable(),
  analyticsLinkText: z.string().nullable(),
  styling: z.string().nullable(),
  localHref: z.string().nullable(),
});

export type RichTextLink = z.infer<typeof RichTextLink>;
